































































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class LoginAdmin extends Vue {
    @Prop(String) source!: string

    loading = false
    formRules = {
        username: [
            (v: string) => !!v || 'Username is required'
        ],
        password: [
            (v: string) => !!v || 'Password is required'
        ]
    }

    formData = {
        username: null,
        password: null
    }

    formValid = false

    async tryLogin () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return
        this.loading = true
        this.$store.dispatch('login', this.formData)
            .then(resp => {
                this.loading = false
                if (resp?.status === 200) {
                    if (resp) {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        let goToRouteOnLogin: any = localStorage.getItem('goToRouteOnLogin')

                        if (goToRouteOnLogin) {
                            goToRouteOnLogin = JSON.parse(goToRouteOnLogin)

                            if (goToRouteOnLogin === '' || goToRouteOnLogin.name === 'Admin') {
                                this.$router.push({ name: 'Dashboard' })
                                localStorage.removeItem('goToRouteOnLogin')
                            } else if (goToRouteOnLogin.name !== 'Login') {
                                this.$router.push({ name: goToRouteOnLogin.name, params: goToRouteOnLogin.params, query: goToRouteOnLogin.query })
                                localStorage.removeItem('goToRouteOnLogin')
                            } else {
                                this.$router.push({ name: 'Dashboard' })
                            }
                        } else {
                            this.$router.push({ name: 'Dashboard' })
                        }

                        this.$store.dispatch('getUserLogued')
                    }
                }
            })
    }
}
